var routes = []
var secondaryRoutes = []
var standaloneRoutes = []

const requireContext = require.context('.', false, /.(core|secondary)\.(js)$/)
requireContext.keys().forEach(file => {
  const routesFile = requireContext(file)

  if ('default' in routesFile) {
    if (file === './secondary.js') {
      secondaryRoutes = secondaryRoutes.concat(routesFile.default)
    } else {
      routes = routes.concat(routesFile.default)
    }
  }
})

export default {routes, secondaryRoutes, standaloneRoutes}
